import myzxios from '../utils/myaxios'

export function getServiceProcess(data) {
    return myzxios({
        url: '/manager/srviceProcess/getServiceProcess',
        data,
        method: 'post'
    })
}

export function actionServiceProcess(data) {
    return myzxios({
        url: '/manager/srviceProcess/actionServiceProcess',
        data,
        method: 'post'
    })
}



export function addServiceProcess(data) {
    return myzxios({
        url: '/manager/srviceProcess/addServiceProcess',
        data,
        method: "post"
    })
}

export function getDiagnosis(data) {
    return myzxios({
        url: '/manager/diagnosis/'+data,
    })
}

export function CMPPClient(data) {
    return myzxios({
        url: '/manager/CMPPClient',
        data,
        method: 'post'
    })
}

export function batchRefurbish(data) {
    return myzxios({
        url: '/manager/srviceProcess/batchRefurbish',
        data,
        method: 'post'
    })
}

export function exportExcel(data) {
    return myzxios({
        url: '/manager/srviceProcess/exportExcel',
        data,
        method: "post"
    })
}